import React from 'react';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import ModalFrame from '../common/ModalFrame';
import ModalFrameMobile from '../common/ModalFrameMobile';
import organizers1 from '../../assets/about/organizers1.png';
import organizers2 from '../../assets/about/organizers2.png';
import organizers3 from '../../assets/about/organizers3.png';
import organizers4 from '../../assets/about/organizers4.png';
import organizers5 from '../../assets/about/organizers5.png';
import organizers6 from '../../assets/about/organizers6.png';


import organizersMobile1 from '../../assets/about/organizersMobile1.png';
import organizersMobile2 from '../../assets/about/organizersMobile2.png';
import organizersMobile3 from '../../assets/about/organizersMobile3.png';
import organizersMobile4 from '../../assets/about/organizersMobile4.png';
import organizersMobile5 from '../../assets/about/organizersMobile5.png';
import organizersMobile6 from '../../assets/about/organizersMobile6.png';


const OrganizerModal = ({ position, card, _handleModal }) => {
  const isMobile = useMediaQuery({
    query: '(max-width: 767px)',
  });
  return (
    <>
      {isMobile ? (
        <ModalMobile top={position} _handleModal={_handleModal}>
          <Title>EFUB organizers</Title>

           <Label>6기</Label>
          <img
            src={organizersMobile6}
            alt="organizersMobile6"
            style={{ width: '100%', marginBottom: '120px' }}
          />

          <Label>5기</Label>
          <img
            src={organizersMobile5}
            alt="organizersMobile5"
            style={{ width: '100%', marginBottom: '120px' }}
          />

          <Label>4기</Label>
          <img
            src={organizersMobile4}
            alt="organizersMobile4"
            style={{ width: '100%', marginBottom: '120px' }}
          />

          <Label>3기</Label>
          <img
            src={organizersMobile3}
            alt="organizersMobile3"
            style={{ width: '100%', marginBottom: '120px' }}
          />

          <Label>2기</Label>
          <img
            src={organizersMobile2}
            alt="organizersMobile2"
            style={{ width: '100%', marginBottom: '120px' }}
          />
          <Label>1기</Label>
          <img
            src={organizersMobile1}
            alt="organizersMobile1"
            style={{ width: '100%' }}
          />
        </ModalMobile>
      ) : (
        <Modal
          top={position}
          _handleModal={_handleModal}
          style={{ padding: '10rem' }}
        >
          <Title>EFUB organizers</Title>
           <Label>6기</Label>
          <img
            src={organizers6}
            alt="organizers6"
            style={{ width: '100%', marginBottom: '120px' }}
          />
          <Label>5기</Label>
          <img
            src={organizers5}
            alt="organizers5"
            style={{ width: '100%', marginBottom: '120px' }}
          />
          <Label>4기</Label>
          <img
            src={organizers4}
            alt="organizers4"
            style={{ width: '100%', marginBottom: '120px' }}
          />
          <Label>3기</Label>
          <img
            src={organizers3}
            alt="organizers3"
            style={{ width: '100%', marginBottom: '120px' }}
          />
          <Label>2기</Label>
          <img
            src={organizers2}
            alt="organizers2"
            style={{ width: '100%', marginBottom: '120px' }}
          />
          <Label>1기</Label>
          <img src={organizers1} alt="organizers1" style={{ width: '100%' }} />
        </Modal>
      )}
    </>
  );
};

export default OrganizerModal;

const Modal = styled(ModalFrame)`
  width: 85%;
  ::-webkit-scrollbar {
    display: block;
    width: 5px;
  }
  ::-webkit-scrollbar-corner {
    display: none;
  }
  ::-webkit-scrollbar-thumb {
    display: block;
    width: 5px;
    background-color: rgba(255, 255, 255, 0.15);
    border-radius: 100px;
    border: 0.1px solid white;
  }
`;

const ModalMobile = styled(ModalFrameMobile)`
  width: 100%;
  ::-webkit-scrollbar {
    display: block;
  }
`;

const Title = styled.div`
  text-align: center;
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 3rem;
  @media (max-width: 767px) {
    font-size: 2rem;
    margin-top: 4rem;
  }
`;

const Label = styled.div`
  width: 100%;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 2rem;
  @media (max-width: 767px) {
    font-size: 1.5rem;
    margin-top: 1rem;
  }
`;
